import React, { useState, useEffect } from 'react';
import './Contacts.css';

const ContactForm = ({ contact, onSave, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    dob: '',
    gender: 'male',
    relation: ''
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (contact) {
      setFormData({
        name: contact.name || '',
        dob: contact.dob ? contact.dob.split('T')[0] : '',
        gender: contact.gender || 'male',
        relation: contact.relation || ''
      });
    }
  }, [contact]);

  const handleChange = (e) => {
    setFormData(prev => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!formData.name.trim()) {
      setError('Name is required');
      return;
    }

    if (!formData.dob) {
      setError('Date of birth is required');
      return;
    }

    setLoading(true);
    try {
      await onSave(formData);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-form-overlay" onClick={onClose}>
      <div className="contact-form-modal" onClick={e => e.stopPropagation()}>
        <div className="contact-form-header">
          <h3>{contact ? 'Edit Contact' : 'Add Contact'}</h3>
          <button className="contact-form-close" onClick={onClose}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          {error && <div className="contact-form-error">{error}</div>}

          <div className="contact-form-field">
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              placeholder="Enter name"
              disabled={loading}
            />
          </div>

          <div className="contact-form-field">
            <label htmlFor="dob">Date of Birth *</label>
            <input
              type="date"
              id="dob"
              name="dob"
              value={formData.dob}
              onChange={handleChange}
              disabled={loading}
            />
          </div>

          <div className="contact-form-row">
            <div className="contact-form-field">
              <label htmlFor="gender">Gender</label>
              <select
                id="gender"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled={loading}
              >
                <option value="male">Male</option>
                <option value="female">Female</option>
                <option value="other">Other</option>
              </select>
            </div>

            <div className="contact-form-field">
              <label htmlFor="relation">Relation</label>
              <select
                id="relation"
                name="relation"
                value={formData.relation}
                onChange={handleChange}
                disabled={loading}
              >
                <option value="">Select...</option>
                <option value="family">Family</option>
                <option value="friend">Friend</option>
                <option value="work">Work</option>
                <option value="partner">Partner</option>
                <option value="other">Other</option>
              </select>
            </div>
          </div>

          <div className="contact-form-actions">
            <button 
              type="button" 
              className="contact-form-cancel"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>
            <button 
              type="submit" 
              className="contact-form-submit"
              disabled={loading}
            >
              {loading ? 'Saving...' : (contact ? 'Update' : 'Add Contact')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;
